module.exports = __webpack_public_path__ + "static/Federica_Rocchi-bbd5154c9df13333cd0e872e5d6d1a25.png";